import { createAction } from '@reduxjs/toolkit'

import { SettingRow } from 'types/GlobalSimFlaw'

import {
  TSimFlawAggregatesDto,
  TSimFlawGroupsDto
} from 'redux/api/internal/SimFlaws/contract'

/**
 * `requestKey` is the scope a groups request was made for - the filters and
 * the page, serialized. It travels on every action, not just the success, so
 * the reducer can tell a response apart from a response to an older request
 * with different filters. See the reducer's scope guard.
 */
// tryGetSimFlawGroups
export const getGroups = createAction<{ requestKey: string }>(
  'internal_get_sim_flaw_groups'
)
export const getGroupsSuccess = createAction<{
  data: TSimFlawGroupsDto
  requestKey: string
}>('internal_get_sim_flaw_groups_success')
export const getGroupsFailed = createAction<{ requestKey: string }>(
  'internal_get_sim_flaw_groups_failed'
)

// tryGetSimFlawAggregates
export const getAggregates = createAction<{ customerId?: string }>(
  'internal_get_sim_flaw_aggregates'
)
export const getAggregatesSuccess = createAction<{
  data: TSimFlawAggregatesDto
  customerId?: string
}>('internal_get_sim_flaw_aggregates_success')
export const getAggregatesFailed = createAction<{ customerId?: string }>(
  'internal_get_sim_flaw_aggregates_failed'
)

// tryGetFlawSettings
export const getSettingsSuccess = createAction<{ data: SettingRow[] }>(
  'internal_get_sim_flaw_settings_success'
)
